import React from "react";

import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";

export default function ModalConsumoMinimo({
  isOpen,
  onRequestClose,
  recipient = "Usuario A",
}) {
  const handleClick = () => {
    window.open("https://www.axsenergia.com.br/#contato ", "_blank");
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Modal"
      style={{ outline: 0 }}
      ariaHideApp={false}
      className={{
        base: "modal-base",
        afterOpen: "modal-base_after-open",
        beforeClose: "modal-base_before-close",
      }}
      overlayClassName={{
        base: "overlay-base",
        afterOpen: "overlay-base_after-open",
        beforeClose: "overlay-base_before-close",
      }}
      shouldCloseOnOverlayClick={true}
    >
      <div className="modal-close" onClick={onRequestClose}></div>
      <div className="modal-imgCheck"></div>
      <div className="modal-text-cep">
        No momento estamos ofertando nossos serviços apenas para residências e
        empresas em <b>Goiás, Mato Grosso, Minas Gerais, Paraná, e São Paulo</b>
        .
      </div>
      <button className="button-modal" onClick={onRequestClose}>
        Voltar
      </button>
      <div className="TextContato" onClick={() => handleClick()}>
        Duvidas?{" "}
        <span className="EsqSenhaPurple">Entre em contato conosco</span>
      </div>
    </Modal>
  );
}
